// extracted by mini-css-extract-plugin
module.exports = {"foregroundImage":"ForegroundImage_foregroundImage__YkciS","trust":"ForegroundImage_trust__mNtxE"};